import React from 'react';
import { useQuery, gql } from '@apollo/client';
import ReactMarkdown from 'react-markdown';
import LegalPageLayout from '@/components/layout/LegalPageLayout';
import { useTranslation } from '@/hooks/useTranslation';
import { NAMESPACES } from '@/i18n/namespaces';

const GET_TERMS_OF_USE = gql`
  query GetTermsOfUse {
    legal(type: TERMS_OF_USE) {
      id
      title
      content
      created_at
      updated_at
    }
  }
`;

const TermsOfUse: React.FC = () => {
  const { t } = useTranslation(NAMESPACES.LEGAL);
  const { data, loading } = useQuery(GET_TERMS_OF_USE);
  
  const title = data?.legal?.title || t('termsOfUse.title');
  const content = data?.legal?.content;
  const updatedAt = data?.legal?.updated_at ? new Date(data.legal.updated_at).toLocaleDateString() : 'June 1, 2023';
  
  return (
    <LegalPageLayout title={title} isLoading={loading}>
      {!loading && (
        <>
          {content ? (
            <div className="markdown-content">
              <ReactMarkdown>{content}</ReactMarkdown>
            </div>
          ) : (
            <>
              <p className="mb-4">
                This is a placeholder for the Terms of Use page. This content will be updated with actual terms and conditions.
              </p>
              
              <section className="mb-6">
                <h3 className="text-xl font-bold mb-3">1. Acceptance of Terms</h3>
                <p className="mb-3">
                  By accessing or using our service, you agree to be bound by these Terms. If you disagree with any part of the terms, 
                  you may not access the service.
                </p>
                <p>
                  Phasellus ac dolor vel felis feugiat aliquam. Integer ac lorem vel nisl venenatis ultricies. 
                  Suspendisse potenti. In hac habitasse platea dictumst.
                </p>
              </section>
              
              <section className="mb-6">
                <h3 className="text-xl font-bold mb-3">2. Use License</h3>
                <p className="mb-3">
                  Permission is granted to temporarily download one copy of the materials on our website for personal, 
                  non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
                </p>
                <p className="mb-3">
                  Under this license, you may not:
                </p>
                <ul className="list-disc pl-5 mb-3">
                  <li className="mb-1">Modify or copy the materials</li>
                  <li className="mb-1">Use the materials for any commercial purpose</li>
                  <li className="mb-1">Attempt to decompile or reverse engineer any software</li>
                  <li className="mb-1">Remove any copyright or other proprietary notations</li>
                  <li>Transfer the materials to another person</li>
                </ul>
              </section>
              
              <section className="mb-6">
                <h3 className="text-xl font-bold mb-3">3. Disclaimer</h3>
                <p className="mb-3">
                  The materials on our website are provided on an 'as is' basis. We make no warranties, expressed or implied, 
                  and hereby disclaims and negates all other warranties including, without limitation, implied warranties or 
                  conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.
                </p>
              </section>
              
              <section className="mb-6">
                <h3 className="text-xl font-bold mb-3">Last Updated</h3>
                <p>These Terms of Use were last updated on {updatedAt}.</p>
              </section>
            </>
          )}
        </>
      )}
    </LegalPageLayout>
  );
};

export default TermsOfUse; 